import React, { createContext, ReactNode } from "react";
import useToken from "../hooks/useToken";

interface AuthContextType {
    auth: {
        userName: string;
        accessToken: string;
        role: string;
        dealerId: string;
        dealerCode: string;
    };
    isAuthenticated: boolean;
    isLoading: boolean;
    logIn: (auth: any) => void;
    logOut: () => void;
    validateToken: () => string;
}

export const AuthContext = createContext<AuthContextType | null>(null);

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const authData = useToken();

    return (
        <AuthContext.Provider value={authData}>
            {children}
        </AuthContext.Provider>
    )
}